import { PayloadAction, createSlice } from "@reduxjs/toolkit";

type PermissionState = {
  availablePermissions: string[];
  userPermissions: string[];
  effectivePermissions: string[];
  accessProfiles: any[];
  loading: boolean;
  error?: string;
  loadedForUserId: string | null;
};

const initialState: PermissionState = {
  availablePermissions: [],
  userPermissions: [],
  effectivePermissions: [],
  accessProfiles: [],
  loading: false,
  error: undefined,
  loadedForUserId: null,
};

const permissionsSlice = createSlice({
  name: "permissions",
  initialState,
  reducers: {
    setPermissionsLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setAvailablePermissions(state, action: PayloadAction<string[]>) {
      state.availablePermissions = action.payload ?? [];
    },
    setUserPermissions(state, action: PayloadAction<string[]>) {
      state.userPermissions = action.payload ?? [];
    },
    setEffectivePermissions(state, action: PayloadAction<string[]>) {
      state.effectivePermissions = action.payload ?? [];
    },
    setAccessProfiles(state, action: PayloadAction<any[]>) {
      state.accessProfiles = action.payload ?? [];
    },
    setPermissionsError(state, action: PayloadAction<string | undefined>) {
      state.error = action.payload;
    },
    setLoadedForUserId(state, action: PayloadAction<string | null>) {
      state.loadedForUserId = action.payload;
    },
    resetPermissions(state) {
      state.availablePermissions = [];
      state.userPermissions = [];
      state.effectivePermissions = [];
      state.accessProfiles = [];
      state.loading = false;
      state.error = undefined;
      state.loadedForUserId = null;
    },
  },
});

export const {
  setPermissionsLoading,
  setAvailablePermissions,
  setUserPermissions,
  setEffectivePermissions,
  setAccessProfiles,
  setPermissionsError,
  setLoadedForUserId,
  resetPermissions,
} = permissionsSlice.actions;

export default permissionsSlice.reducer;
